import { Link } from "react-router-dom";
import "./index.css";
const Header = () => {
  return (
    <nav className="nav-header">
      <Link to="/" className="nav-link">
        <h1 className="blog-title">Receive SMS Online </h1>
      </Link>

      <ul className="nav-menu">
        <li className="nav-item-pp">
          <Link className="nav-link" to="/terms">
            Privacy Policy
          </Link>
        </li>
        <li className="nav-item-pp" >
          <Link className="nav-link" to="/faq">
            F.A.Q
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Header;
